import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import Button from "@mui/material/Button";
import { withRouter } from "react-router";
import { withSnackbar } from "notistack";
import { v4 as uuidv4 } from "uuid";
import { Helmet } from "react-helmet";
import { useInterval } from "react-interval-hook";

import Report from "./report";
import Loader from "../components/common/Loader";
import SearchFilter from "../components/common/SearchFilter";
import WorkListStatusFilter from "../components/features/worklist-status-filter";

import { getWorklist } from "../api/api";
import {
  ROWS_PER_PAGE,
  WORKLIST_COLUMN_PROPERTIES_REF,
} from "../utils/constants";

import { useAuthUser } from "../store/AuthUserContextProvider";

const Worklist = (props) => {
  const [worklist, setWorklist] = useState({
    list: [],
    filtered: [],
  });
  const [currentProcedure, setCurrentProcedure] = useState({
    index: null,
    data: null,
    isFor: null,
  });
  const [filter, setFilter] = useState({
    date: {
      start: null,
      end: null,
    },
    string: "",
    statusValues: [],
  });
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [openReport, setOpenReport] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const { authUser } = useAuthUser();
  const FILTER_APPLIED = filter.string || filter.statusValues.length;
  const ALLOW_WORKLIST_DATA_UPDATE = !Boolean(
    currentProcedure.isFor === "PROCEDURE_CANCELATION" ||
      openReport ||
      loading ||
      FILTER_APPLIED
  );

  console.log("authUser",authUser);

  const getWorklistData = async () => {
    const [res, err] = await getWorklist(
      `/worklist/refDoc/${authUser.UserName}`
    );

    if (res) {
      setWorklist({
        list: res.data,
        filtered: res.data,
      });

      setLoading(false);
    } else {
      setLoading(false);
      console.error(err.message);
      props.enqueueSnackbar(`ERROR: ${err.message}`, {
        preventDuplicate: true,
        variant: "error",
      });
    }
  };

  useEffect(() => {
    getWorklistData();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("enable-edit-user")) {
      localStorage.setItem("enable-edit-user", "");
    } else if (currentProcedure.isFor === "REPORT") {
      handleOpenReport();
    }
  }, [currentProcedure]);

  useEffect(() => {
    if (filter.string || filter.statusValues.length) {
      const filteredWorklist = filter.string
        ? getFilteredWorklist(filter.string, worklist.list)
        : worklist.list;

      if (filter.statusValues.length > 0) {
        let temp_worklist_data = [];

        filter.statusValues.map((value) => {
          temp_worklist_data.push.apply(
            temp_worklist_data,
            getFilteredWorklistByStatus(value, filteredWorklist)
          );
        });

        filteredWorklist = [...temp_worklist_data];
      }

      setWorklist({
        ...worklist,
        filtered: filteredWorklist,
      });
    } else {
      setWorklist({
        ...worklist,
        filtered: worklist.list,
      });
    }
  }, [filter]);

  useInterval(
    () => {
      if (ALLOW_WORKLIST_DATA_UPDATE) {
        getWorklistData();
        console.log("fething new tings");
      }
    },
    15000,
    {
      immediate: false,
    }
  );

  const handleViewReport = async (index) => {
    const worklist_copy = [...worklist.filtered];
    const row = worklist_copy[index];

    localStorage.setItem("current-study-and-report", JSON.stringify(row));
    const reportPrinterTriggerBtn = document.querySelector(
      "#report-printer-trugger-btn"
    );

    if (reportPrinterTriggerBtn) {
      reportPrinterTriggerBtn.click();
    }
  };

  const handleSetWorklist = (list) => {
    setWorklist({
      list: list,
      filtered: list,
    });
  };

  const cleanOutCurrentProcedure = () => {
    setCurrentProcedure({
      index: null,
      isFor: null,
      data: null,
    });
  };

  const handleOpenReport = () => setOpenReport(true);
  const handleCloseReport = () => {
    setOpenReport(false);
    cleanOutCurrentProcedure()
  };


  const handleChangePage = (_, newPage) => setPage(newPage);

  const handleFilterStartDate = (val) => {
    setFilter({
      ...filter,
      date: {
        ...filter.date,
        start: val,
      },
    });
  };

  const handleFilterEndDate = (val) => {
    setFilter({
      ...filter,
      date: {
        ...filter.date,
        end: val,
      },
    });
  };


  const handleFilterStringChange = (e) => {
    e.preventDefault();
    setFilter({
      ...filter,
      string: e.target.value,
    });
  };

  const handleFilterStatusChange = (_, statuses) => {
    setFilter({
      ...filter,
      statusValues: statuses,
    });
  };

  const getFilteredWorklist = (filterString, studies) => {
    const str = filterString.toLowerCase();
    if (!str) return studies;
    else {
      return studies.filter(
        (study) =>
          (study.LastName && study.LastName.toLowerCase().includes(str)) ||
          (study.FirstName && study.FirstName.toLowerCase().includes(str)) ||
          (study.Procedure && study.Procedure.toLowerCase().includes(str)) ||
          (study.Branch && study.Branch.toLowerCase().includes(str))
      );
    }
  };

  const getFilteredWorklistByStatus = (status, studies) => {
    return studies.filter(
      (study) =>
        study.Status && study.Status.toLowerCase() === status.toLowerCase()
    );
  };

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * ROWS_PER_PAGE - worklist.filtered.length)
      : 0;

  return (
    <>
      <Helmet>
        <title>Ref Doctor Worklist</title>
      </Helmet>

      {openReport ? (
        <Report
          worklist={worklist.list}
          procedure={currentProcedure}
          isDone={isDone}
          close={handleCloseReport}
          updateWorklist={handleSetWorklist}
        />
      ) : (
        <Box sx={{ width: "100%" }}>
          <SearchFilter
            handleChange={handleFilterStringChange}
            val={filter.string}
            placeholder={
              "Filter by 'First/Last Name', 'Branch', or 'Procedure' "
            }
          />

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <WorkListStatusFilter handleChange={handleFilterStatusChange} />
              </Grid>
              <Grid item xs={2}>
                <DesktopDatePicker
                  label="From"
                  inputFormat="MM/dd/yyyy"
                  value={filter.date.start}
                  onChange={handleFilterStartDate}
                  renderInput={(params) => <TextField fullWidth {...params} />}
                />
              </Grid>

              <Grid item xs={2}>
                <DesktopDatePicker
                  label="To"
                  inputFormat="MM/dd/yyyy"
                  value={filter.date.end}
                  onChange={handleFilterEndDate}
                  renderInput={(params) => <TextField fullWidth {...params} />}
                />
              </Grid>
            </Grid>
          </LocalizationProvider>

          {loading ? (
            <Loader />
          ) : (
            <Paper sx={{ width: "100%", mb: 2 }}>
              <TableContainer>
                <Table sx={{ minWidth: 750 }}>
                  <TableHead>
                    <TableRow>
                      {WORKLIST_COLUMN_PROPERTIES_REF.map((column) => (
                        <TableCell
                          style={{ backgroundColor: "black" }}
                          key={uuidv4()}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  {/*  */}

                  <TableBody>
                    {worklist.filtered
                      .slice(
                        page * ROWS_PER_PAGE,
                        page * ROWS_PER_PAGE + ROWS_PER_PAGE
                      )
                      .map((procedure, index) => (
                        <TableRow hover key={uuidv4()}>
                          <TableCell component="th" scope="procedure">
                            {procedure.IDNumber}
                          </TableCell>
                          <TableCell align="left">
                            {procedure.Accession}
                          </TableCell>
                          <TableCell align="left">
                            {procedure.FirstName}
                          </TableCell>
                          <TableCell align="left">
                            {procedure.LastName}
                          </TableCell>
                          <TableCell align="left">
                            {procedure.Procedure}
                          </TableCell>
                          <TableCell align="left">{procedure.Branch}</TableCell>
                          <TableCell align="left">
                            <Button
                              onClick={() => handleViewReport(index)}
                              variant="outlined"
                              size="small"
                              color={`${
                                procedure.Status.toUpperCase() === "DONE"
                                  ? "success"
                                  : "warning"
                              }`}
                              style={{ width: "130px" }}
                              disabled={
                                procedure.Status.toUpperCase() === "DONE"
                                ? false
                                : true
                              }
                            >
                              View Report
                            </Button>
                          </TableCell>

                          <TableCell align="center">
                            <Button
                              variant="outlined"
                              style={{ width: "130px" }}
                              size="small"
                              color="secondary"
                              href={`http://192.168.50.241:90?accnum=${procedure.Accession}`}
                              target="_blank"
                            >
                              {"View Scan"}
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}

                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                rowsPerPageOptions={[ROWS_PER_PAGE]}
                rowsPerPage={ROWS_PER_PAGE}
                count={worklist.list.length}
                page={page}
                onPageChange={handleChangePage}
              />
            </Paper>
          )}
        </Box>
      )}
       <a
        href="/report-printer"
        target="_blank"
        id="report-printer-trugger-btn"
      />
    </>
  );
};

export default withSnackbar(withRouter(Worklist));
